import { render, staticRenderFns } from "./reserveBanner.vue?vue&type=template&id=1755a07c"
import script from "./reserveBanner.vue?vue&type=script&lang=js"
export * from "./reserveBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports